/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React from "react";
import { Box } from "@chakra-ui/react";
import { buildImageUrl } from "../utils/theme1Helpers";
import Swal from "sweetalert2";
import ThreeDImageCarousel from "./ThreeDImageCarousel";

export default function HeroSection({
  storeData,
  apiProducts,
  apiCategories,
  apiBanners,
  storeReviews,
  theme,
  isMobile,
  isTablet,
}) {
  const activeBanners = (apiBanners || []).filter((b) => b.active);

  const averageRating =
    storeReviews.length > 0
      ? (storeReviews.reduce((sum, review) => sum + review.rating, 0) / storeReviews.length).toFixed(1)
      : "5.0";

  return (
    <Box mb="50px" dir="rtl" p={isMobile ? "15px" : "0 40px"}>
      <div
        style={{
          display: "flex",
          gap: isMobile ? "24px" : "50px", // Increased gap
          flexDirection: isMobile ? "column" : "row",
          alignItems: "center", // Kept centered as requested
          maxWidth: "1400px",
          marginTop: 0,
          marginBottom: 0,
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        {/* 1. كرت معلومات المتجر */}
        <div
          style={{
            flex: isMobile ? "none" : "1",
            background: "white",
            padding: isMobile ? "30px" : "40px",
            borderRadius: "32px",
            border: "1px solid #F0F0F0",
            boxShadow: `0 20px 50px ${theme.primary}0A`,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            position: "relative",
            minHeight: isMobile ? "auto" : "450px",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              width: "100%",
              height: "100%",
              background: `linear-gradient(135deg, white 0%, ${theme.primary}05 100%)`,
              zIndex: 0,
              borderRadius: "32px",
            }}
          />

          <div style={{ position: "relative", zIndex: 1 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "18px",
                marginBottom: "28px",
              }}
            >
              <div
                style={{
                  width: isMobile ? "55px" : "70px",
                  height: isMobile ? "55px" : "70px",
                  background: `linear-gradient(135deg, ${theme.primary} 0%, ${theme.primaryDark} 100%)`,
                  borderRadius: "22px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: `0 10px 25px ${theme.primary}33`,
                }}
              >
                <span style={{ fontSize: isMobile ? "28px" : "36px" }}>🏪</span>
              </div>
              <div>
                <h4
                  style={{
                    margin: 0,
                    fontSize: isMobile ? "14px" : "16px",
                    color: theme.primary,
                    fontWeight: "700",
                    marginBottom: "4px",
                  }}
                >
                  {storeData.storeSlogan || storeData.SectorType || "مرحباً بك"}
                </h4>
                <h2
                  style={{
                    margin: 0,
                    fontSize: isMobile ? "22px" : "30px",
                    fontWeight: "900",
                    color: "#1A202C",
                    lineHeight: "1.2",
                  }}
                >
                  {storeData.storeName || storeData.ClientName || "متجرنا"}
                </h2>
              </div>
            </div>

            <p
              style={{
                fontSize: isMobile ? "14px" : "16px",
                color: "#4A5568",
                lineHeight: "1.7",
                marginBottom: "32px",
                fontWeight: "500",
                opacity: 0.9,
              }}
            >
              {storeData.description || "استكشف مجموعتنا الواسعة من المنتجات المختارة بعناية لتناسب أذواقكم العالية."}
            </p>

            <div
              style={{
                display: "flex",
                gap: "12px",
                marginBottom: "32px",
                flexWrap: "wrap",
              }}
            >
              {[
                { icon: "🛡️", text: "أمان تام", color: "#48BB78" },
                { icon: "⚡", text: "توصيل سريع", color: "#ED8936" },
                { icon: "🎁", text: "أفضل قيمة", color: theme.primary },
              ].map((ft, i) => (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    padding: "6px 14px",
                    background: `${ft.color}0A`,
                    borderRadius: "100px",
                    border: `1px solid ${ft.color}1A`,
                  }}
                >
                  <span style={{ fontSize: "14px" }}>{ft.icon}</span>
                  <span style={{ fontSize: "12px", fontWeight: "700", color: ft.color }}>{ft.text}</span>
                </div>
              ))}
            </div>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "1px",
              background: "#F0F0F0",
              borderRadius: "24px",
              overflow: "hidden",
              border: "1px solid #F0F0F0",
              position: "relative",
              zIndex: 1,
            }}
          >
            {[
              { label: "منتج", value: `${apiProducts.length}+` },
              { label: "فئة", value: `${apiCategories.length}+` },
              { label: "تقييم", value: `${averageRating}★` },
            ].map((stat, i) => (
              <div
                key={i}
                style={{
                  textAlign: "center",
                  background: "white",
                  padding: "15px 10px",
                }}
              >
                <div
                  style={{
                    fontSize: isMobile ? "20px" : "24px",
                    fontWeight: "900",
                    color: "#1A202C",
                    lineHeight: "1",
                  }}
                >
                  {stat.value}
                </div>
                <div
                  style={{
                    fontSize: "12px",
                    fontWeight: "600",
                    color: "#718096",
                    marginTop: "6px",
                  }}
                >
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 2. قسم البانر - 3D Carousel */}
        <div
          style={{
            flex: isMobile ? "none" : "1.6",
            height: isMobile ? "260px" : isTablet ? "340px" : "420px",
            position: "relative",
            minWidth: 0,
            maxWidth: isMobile ? "100%" : "900px",
            width: "100%",
            marginTop: isMobile ? 0 : "auto",
            marginBottom: isMobile ? 0 : "auto",
            marginLeft: isMobile ? "auto" : 0,
            marginRight: isMobile ? "auto" : 0,
            alignSelf: "center",
            borderRadius: isMobile ? "18px" : "26px",
            overflow: "hidden", // Restored to prevent overlapping with other sections
          }}
        >
          {activeBanners.length > 0 ? (
            <ThreeDImageCarousel
              slides={activeBanners.map((b, i) => ({
                id: b.id || i,
                src: buildImageUrl(b.imageUrl),
                href: b.link || "#",
                alt: b.name || `banner-${i + 1}`,
              }))}
              itemCount={5}
              autoplay
              delay={3}
              pauseOnHover
              className="bg-transparent"
            />
          ) : (
            <div style={{ width: "100%", height: "100%", background: "#F7FAFC", borderRadius: "32px", display: "flex", alignItems: "center", justifyContent: "center" }}>
              لا توجد عروض
            </div>
          )}
        </div>
      </div>

      {/* Policies Section */}
      {storeData.policies && (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: isMobile ? "1fr" : isTablet ? "repeat(2,1fr)" : "repeat(3,1fr)",
            gap: "20px",
            marginTop: "60px",
          }}
        >
          {[
            { key: "privacy", icon: "🔐", title: "سياسة الخصوصية", desc: "تعرف كيف نحمي بياناتك" },
            { key: "delivery", icon: "🚚", title: "سياسة التوصيل", desc: "معلومات الشحن والتوصيل" },
            { key: "refund", icon: "↩️", title: "سياسة الاسترجاع", desc: "شروط الإرجاع والاستبدال" },
          ].map(
            (policy) =>
              storeData.policies[policy.key] && (
                <div
                  key={policy.key}
                  onClick={() =>
                    Swal.fire({
                      title: policy.title,
                      text: storeData.policies[policy.key],
                      confirmButtonText: "حسناً",
                      confirmButtonColor: theme.primary,
                    })
                  }
                  style={{
                    background: "white",
                    display: "flex",
                    alignItems: "center",
                    gap: "18px",
                    padding: "22px 28px",
                    borderRadius: "24px",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    border: "1px solid #F0F0F0",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.03)"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-5px)";
                    e.currentTarget.style.boxShadow = `0 15px 30px ${theme.primary}15`;
                    e.currentTarget.style.borderColor = `${theme.primary}33`;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.03)";
                    e.currentTarget.style.borderColor = "#F0F0F0";
                  }}
                >
                  <div
                    style={{
                      fontSize: "26px",
                      width: "55px",
                      height: "55px",
                      background: `${theme.primary}0D`,
                      borderRadius: "18px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    {policy.icon}
                  </div>
                  <div style={{ flex: 1 }}>
                    <h4
                      style={{
                        margin: 0,
                        fontSize: "16px",
                        fontWeight: "700",
                        color: "#1A202C",
                      }}
                    >
                      {policy.title}
                    </h4>
                    <p
                      style={{
                        marginTop: "4px",
                        marginBottom: 0,
                        marginLeft: 0,
                        marginRight: 0,
                        fontSize: "13px",
                        color: "#718096",
                        fontWeight: "500",
                      }}
                    >
                      {policy.desc}
                    </p>
                  </div>
                </div>
              )
          )}
        </div>
      )}
    </Box>
  );
}
